import { Controller } from "@hotwired/stimulus"

// Toggles the collapsible capabilities list within a role card.
export default class extends Controller {
  static targets = ["content", "label"]

  toggle(event) {
    event.preventDefault()

    const isHidden = this.contentTarget.classList.contains("hidden")
    this.contentTarget.classList.toggle("hidden")

    if (this.hasLabelTarget) {
      const text = this.labelTarget.textContent
      if (isHidden) {
        this.labelTarget.textContent = text.replace("View", "Hide")
      } else {
        this.labelTarget.textContent = text.replace("Hide", "View")
      }
    }
  }
}
